module.exports = __webpack_public_path__ + "img/help-banner.596e32e4.jpg";